import React, {ReactNode} from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";

interface Props {
    children: ReactNode,
}

const AppContainer = (props: Props) => {
    return (
        <Container className={"container-xl"}>
            {props.children}
        </Container>
    )
}

export default AppContainer

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${Colors.white};
  
  margin-bottom: 50px;
`
